import { render, staticRenderFns } from "./HousingAssignments.vue?vue&type=template&id=f620a196&scoped=true&"
import script from "./HousingAssignments.vue?vue&type=script&lang=js&"
export * from "./HousingAssignments.vue?vue&type=script&lang=js&"
import style0 from "./HousingAssignments.vue?vue&type=style&index=0&id=f620a196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f620a196",
  null
  
)

export default component.exports